"use strict";

const style = require("!!css-loader!./style/index.css").default;

module.exports =`
    <style>${style}</style>
    <header>
        <a href="https://www.swift.com/" target="_blank" itemtype="https://schema.org/Organization" title="Header logo">
            <img src="" alt="Header logo">
        </a>
        <nav class="links"></nav>
    </header>
`;
